export const TranslationKeys = {
  // Common
  LOADING: 'Loading',
  REFRESH: 'Refresh',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  EDIT: 'Edit',
  
  // Report Types
  REPORT_TYPE: 'ReportType',
  ALL_LOCATIONS: 'AllLocations',
  SELECT_LOCATION: 'SelectLocation',
  ALL_DEVICES: 'AllDevices',
  SELECT_DEVICE: 'SelectDevice',
  
  // Comparison
  PLEASE_SELECT_TWO_LOCATIONS: 'PleaseSelectTwoLocations',
  PLEASE_SELECT_TWO_DEVICES: 'PleaseSelectTwoDevices',
  PLEASE_SELECT_TWO_REPORTS: 'PleaseSelectTwoReports',
  PLEASE_SELECT_TWO_TIMEFRAMES: 'PleaseSelectTwoTimeFrames',
  
  // Limits
  MAX_LOCATIONS_LIMIT: 'MaxLocationsLimit',
  MAX_DEVICES_LIMIT: 'MaxDevicesLimit',
  MAX_REPORTS_LIMIT: 'MaxReportsLimit',
  MAX_TIMEFRAMES_LIMIT: 'MaxTimeFramesLimit',
  MIN_LOCATIONS_DEVICES: 'MinLocationsDevices',
  MIN_DEVICES_MAX: 'MinDevicesMax',

  // Comparison Warnings
  FOR_DAY_COMPARISON_PLEASE_SELECT_A_SINGLE_DAY_00_00_23_59: 'DayComparisonWarning',
  FOR_WEEK_COMPARISON_PLEASE_SELECT_A_MONDAY_MONDAY_00_00_SUNDAY_23_59: 'WeekComparisonWarning',
  FOR_MONTH_COMPARISON_PLEASE_SELECT_THE_1ST_OF_THE_MONTH_1ST_00_00_LAST_DAY_23_59: 'MonthComparisonWarning',
  FOR_YEAR_COMPARISON_PLEASE_SELECT_JANUARY_1ST_JAN_1ST_00_00_DEC_31ST_23_59: 'YearComparisonWarning',

  PLEASE_SELECT_EXACTLY_TWO_REPORTS_FOR_COMPARISON: 'PleaseSelectExactlyTwoReportsForComparison',
  PLEASE_SELECT_ONLY_TWO_TIME_FRAMES_FOR_COMPARISON: 'PleaseSelectOnlyTwoTimeFramesForComparison',
  PLEASE_SELECT_EXACTLY_TWO_TIME_FRAMES_FOR_COMPARISON: 'PleaseSelectExactlyTwoTimeFramesForComparison',
  INVALID_TIME_FRAME_COMBINATION_SELECTED: 'InvalidTimeFrame',

  // Messages
  SAVED_SUCCESSFULLY: 'SAVED',
  UPDATED_SUCCESSFULLY: 'UPDATED',
  DELETED_SUCCESSFULLY: 'DELETED',
  
  // Custom 
  CUSTOM_RANGE: 'CustomRange',
  DEFAULT: 'Default',
  GROUP_EXPORT: 'GroupExport',
  FLAT_EXPORT: 'FlatExport',
  SELECTION_LIMIT_EXCEEDED: 'SelectionLimitExceeded',
} as const;
